import { ReactElement } from 'react';
import type { CallSetting } from '../types';
import { SEGMENT_LABEL } from '../constants';
import JobNumberList from './JobNumberList';
import ScheduleEditor from './ScheduleEditor';
import { SectionCard, CardTitle, AdvertisementCodeText, SubSection } from './styles';

interface Props {
  setting: CallSetting;
}

const AdvertisementSection = ({ setting }: Props): ReactElement => {
  const { id, koukokuCode, segment } = setting;
  return (
    <SectionCard>
      <CardTitle>{SEGMENT_LABEL[segment] ?? segment}</CardTitle>
      <AdvertisementCodeText>広告コード: {koukokuCode}</AdvertisementCodeText>
      <SubSection>
        <JobNumberList advertisementId={id} />
      </SubSection>
      <SubSection>
        <ScheduleEditor advertisementId={id} />
      </SubSection>
    </SectionCard>
  );
};

export default AdvertisementSection;
